import { IQueryRequest } from '../../../interfaces/request';
import { useQuery } from 'react-query';
import { getGraspsSettings } from '../../graspManagement';
import QueryKeys from '../queryKeys';
import { OrganizationQueryParams } from '../../../interfaces/queryParams';

const useGraspSettings = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getGraspsSettings(params.organizationId);
      return data.data;
    },
    queryKey: [QueryKeys.getGraspsSettings, params.organizationId],
  });
};

export default useGraspSettings;
